"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const string_1 = require("../../helpers/string/string");
const Loader_styled_1 = require("./Loader.styled");
const Loader = ({ className }) => ((0, jsx_runtime_1.jsx)(Loader_styled_1.LoaderStyled, { className: (0, string_1.getClassName)('octo', className), children: (0, jsx_runtime_1.jsx)("div", { className: "spin", children: (0, jsx_runtime_1.jsx)("div", { className: "spin-interior" }) }) }));
exports.Loader = Loader;
//# sourceMappingURL=Loader.js.map